export default __webpack_public_path__ + "static/media/indicator-low.01c27636.png";